// ============================================
// Loader Component
// ============================================

import { Loader2 } from 'lucide-react';
import { cn } from './ui';

export function Loader({ fullScreen = false, size = 'md' }: { fullScreen?: boolean; size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <Loader2 className={cn(sizeClasses[size], 'text-primary animate-spin')} />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-8">
      <Loader2 className={cn(sizeClasses[size], 'text-primary animate-spin')} />
    </div>
  );
}